<template>
	<div>
		<img @click="actionGoTo" class="sk-navigation-link__icon" :src="`/static/svg/${icon}`" :title="title" :alt="title">
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	name: 'navigation-link',
	props: {
		title: {
			type: String,
			default: null
		},
		icon: {
			type: String,
			default: 'idicare'
		}
	},
	methods: {
		actionGoTo() {
			this.$root.$emit('navigation-close')
			this.$emit('click');
		}
	}
}
</script>

<style scoped>
	.sk-navigation-link__icon {
		display: block;
		width: 24px;
		height: 24px;
		margin: 15px;
		cursor: pointer;
		transition: transform 0.3s;
	}
	.sk-navigation-link__icon:hover {
		transform: scale(1.2, 1.2);
	}
</style>



// WEBPACK FOOTER //
// src/components/navigation/NavigationButtonIcon.vue